import React, { useState, useEffect } from "react";
import { useAuth } from "../../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useShoppingContext } from "../../../context/ShoppingContext";

const SignInForm = () => {
  const { handleLogin, error, setAuthenticatedUser } = useAuth();
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para controlar la carga
  const [formClass, setFormClass] = useState("sign-form-container"); // Clase CSS para el formulario
  const { setIsButtonClicked, animationClass, fetchMisAves, fetchMisGalpones, fetchMisGranjas, fetchAlimentos, fetchControlAves, fetchControlAlimentos} = useShoppingContext();

  const navigate = useNavigate();

  useEffect(() => {
    // Activar la animación cuando el componente se monta
    setTimeout(() => {
      setFormClass("sign-form-container show-form");
    }, 100); // Se da un pequeño delay para permitir que la transición se vea más fluida
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginData.email || !loginData.password) {
      console.error("Todos los campos son obligatorios.");
      return;
    }

    setLoading(true); // Activar la rueda de carga al iniciar la solicitud

    try {
      // Intentar iniciar sesión
      const loginResponse = await handleLogin(loginData);

      // Si la autenticación es exitosa, continuar
      if (loginResponse && loginResponse.success) {
        // Redirigir si el login fue exitoso
        fetchMisGranjas();
        fetchMisAves();
        fetchMisGalpones();
        fetchAlimentos();
        fetchControlAves();
        fetchControlAlimentos();
        setAuthenticatedUser(loginResponse.data);
        navigate("/mis-granjas");
      } else {
        console.error(
          "Error al iniciar sesión: ",
          loginResponse?.message || "Credenciales incorrectas"
        );
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
    } finally {
      setLoading(false); // Desactivar la rueda de carga
      setIsButtonClicked(false); // Cerrar el formulario si es necesario
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSignUpRedirect = () => {
    setTimeout(() => {
      navigate("/create");
      setIsButtonClicked(false);
    }, 1000); // 2 segundos de espera para el efecto de giro
  };

  return (
    <div className={`${formClass} rounded shadow-lg ${animationClass}`}>
      <form onSubmit={handleSubmit} className="signin-form">
        <h1>Iniciar sesión</h1>
        <div>
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={loginData.email}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <div>
          <label>Contraseña</label>
          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={loginData.password}
              onChange={handleChange}
              required
              className="form-control"
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              onClick={togglePasswordVisibility}
              className="password-icon"
            />
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}

        {loading ? (
          <div className="loading-spinner">
            <div className="spinner"></div> {/* Añadir un spinner animado */}
            Cargando...
          </div>
        ) : (
          <button
            type="submit"
            className="btn btn-green btn-bigger btn-now login-submit"
          >
            Iniciar Sesión
          </button>
        )}

        <div className="signup-redirect">
          <p onClick={handleSignUpRedirect}>
            ¿No tienes una cuenta? Regístrate
          </p>
        </div>
      </form>
    </div>
  );
};

export default SignInForm;
